import { cn, STATUS_PILL, STATUS_LABEL } from "@/lib/utils";

export default function StatusPill({ status, className }) {
  const key = String(status || "").toLowerCase().replace(/\s+/g, "_");
  const cls = STATUS_PILL[key] || "bg-gray-100 text-gray-700 border-gray-200";
  const label = STATUS_LABEL[key] || status;
  return (
    <span
      data-testid={`status-pill-${key}`}
      className={cn("pill", cls, className)}
    >
      <span className={cn("pill-dot", "bg-current opacity-60")} />
      {label}
    </span>
  );
}
